export const SERVICE_PAGE_UI = {
    en: {
        typesSection: {
            title: "Screen Options",
            subtitle: "From motorized patio screens to solar and insect mesh, explore the retractable systems we design, build, and install.",
            ariaPrev: "Previous Slide",
            ariaNext: "Next Slide",
            readMore: "Learn More"
        },
        middleSection: {
            startProject: "Get a Free Quote",
            bookCall: "Talk to Us",
            caseStudyLabel: "Recent Project",
            viewprojects: "See Our Work"
        },
        servicesListSection: {
            headline: "Our Services",
            subHeadline: "Retractable screen solutions for patios, pools, pergolas, and entryways, custom built and professionally installed.",
            learnMore: "Learn More",
            callNow: "Talk to Us",
            viewAll: "All Services"
        },
        servicesPage: {
            introTitle: "Built for outdoor living, installed to last",
            introSubtitle: "We measure, fabricate, and install each retractable screen to fit your space precisely, so it looks clean, runs smooth, and holds up to sun, wind, and salt air.",
            whyChooseTitle: "Why Choose Us",
            whyChooseText: "Custom fit motorized and manual screens, premium mesh rated for sun and insects, professional in house installation crews, and workmanship plus manufacturer warranties on every job.",
            ctaTitle: "Ready to enjoy your outdoor space?",
            ctaSubtitle: "Book a free, no obligation on site assessment and quote, we'll recommend the right screen for every opening.",
            ctaText: "Get a Free Quote",
            faqTitle: "Common Questions"
        }
    },
    he: {
        typesSection: {
            title: "אפשרויות רשת",
            subtitle: "מרשתות ממונעות למרפסת ועד רשתות סולאריות ונגד יתושים, הכירו את המערכות הנגללות שאנחנו מתכננים, מייצרים ומתקינים.",
            ariaPrev: "שקופית קודמת",
            ariaNext: "שקופית הבאה",
            readMore: "קראו עוד"
        },
        middleSection: {
            startProject: "להצעת מחיר חינם",
            bookCall: "דברו איתנו",
            caseStudyLabel: "פרויקט אחרון",
            viewprojects: "לעבודות שלנו"
        },
        servicesListSection: {
            headline: "השירותים שלנו",
            subHeadline: "פתרונות רשת נגללת למרפסות, בריכות, פרגולות וכניסות, בהתאמה אישית ובהתקנה מקצועית.",
            learnMore: "קראו עוד",
            callNow: "דברו איתנו",
            viewAll: "לכל השירותים"
        },
        servicesPage: {
            introTitle: "בנוי למגורים בחוץ, מותקן להחזיק שנים",
            introSubtitle: "אנחנו מודדים, מייצרים ומתקינים כל רשת נגללת בהתאמה מדויקת למרחב שלכם, כך שהיא נראית נקייה, פועלת חלק ועומדת בשמש, ברוח ובאוויר הים.",
            whyChooseTitle: "למה לבחור בנו",
            whyChooseText: "רשתות ממונעות וידניות בהתאמה אישית, רשת איכותית עמידה בשמש ובחרקים, צוותי התקנה מקצועיים משלנו, ואחריות עבודה ואחריות יצרן על כל עבודה.",
            ctaTitle: "מוכנים ליהנות מהמרחב שבחוץ?",
            ctaSubtitle: "קבעו בדיקה והצעת מחיר חינם, ללא התחייבות, נמליץ על הרשת הנכונה לכל פתח.",
            ctaText: "להצעת מחיר חינם",
            faqTitle: "שאלות נפוצות"
        }
    }
};

export const getServicePageUI = (lang = 'en') => {
    return SERVICE_PAGE_UI[lang] || SERVICE_PAGE_UI['en'];
};
